import { getQueryClient } from 'app/get-query-client';
import * as logrocket from 'lib/logrocket';
import { useAuthStore } from 'lib/stores/authStore';
import { bankTransfersKeys, getBankTransfersFromCache, getHasDepositedBefore } from 'queries/bankTransfers';

export function trackFirstDepositIfLeaving(): void {
    const userId = useAuthStore.getState().userId ?? '';
    // No query state at all (nothing has fetched yet) or a 'pending' status (neither
    // data nor an error yet) both mean "not loaded" — mirroring the old
    // BanksStore.loadedTransfers guard against acting on unloaded data.
    const queryState = getQueryClient().getQueryState(bankTransfersKeys.user(userId));
    const loadedTransfers = queryState !== undefined && queryState.status !== 'pending';
    if (loadedTransfers && !getHasDepositedBefore(getBankTransfersFromCache(userId))) {
        logrocket.trackFirstDeposit();
    }
}
